<template>
  <div class="container">
    <div class="cards-menu">
      <div v-for="(item, index) in catalogueList" :key="index">
        <Suspense>
          <template #default>
            <Card
              :title="item.title"
              :description="item.subtitle"
              :image="item.image"
              @click="goTo(item.goTo)"
            >
            </Card>
          </template>
          <template #fallback>
            <CardSkeleton />
          </template>
        </Suspense>
      </div>
    </div>
  </div>
</template>

<script setup>
  import Card from '@/components/movistar/cards/CardOption.vue'
  import CardSkeleton from '@/components/movistar/skeletons/CardSkeleton.vue'
  import router from '@/router'
  import i18n from '@/plugins/i18n'
  const { t } = i18n.global

  const catalogueList = [
    {
      title: t('catalogue.devices.title'),
      subtitle: t('catalogue.devices.subtitle'),
      image: 'storeOptionsImages/conectivity.png',
      goTo: 'dispositives'
    },
    {
      title: t('catalogue.household-appliances.title'),
      subtitle: t('catalogue.household-appliances.subtitle'),
      image: 'storeOptionsImages/conectivity.png',
      goTo: 'homeAppliances'
    }
  ]

  const goTo = (type) => {
    router.push({ path: type })
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/mixings';
  .cards-menu {
    @include d-flex(column, flex-start, initial);
    gap: 20px;
    padding: 15px 33px;
    height: 100%;
    overflow-y: auto;
    background: #f6f6f6;
    &__title {
      padding: 15px 0;
      margin: auto;
      font-size: 30px;
      font-weight: var(--fw-bold);
    }
  }
</style>
